var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useMemo, useState, useRef, useEffect, useContext } from 'react';
import { translate } from '@utils/i18n';
import { Controller, useFormContext } from 'react-hook-form';
import { Duration } from 'luxon';
import { Popup } from '@progress/kendo-react-popup';
import { InlineEdit } from '@components/v2/InlineEdit';
import { EditGenericEventModalContext } from '../../context/EditGenericEventModalContext';
function DurationComp() {
    const namespace = 'features.modals.edit_generic_event_modal.details_section.duration';
    const [open, setOpen] = useState(false);
    const anchor = useRef(null);
    const popup = useRef(null);
    const { watch, control, getValues, trigger, formState: { errors } } = useFormContext();
    const { handleModalSave } = useContext(EditGenericEventModalContext);
    const formValues = watch();
    const duration = useMemo(() => Duration.fromObject({ minutes: formValues.durationMins }).shiftTo('days', 'hours', 'minutes'), [formValues.durationMins]);
    const handleDurationChange = (field, newDuration) => {
        const newDurationMins = Duration.fromObject(Object.assign({ days: duration.days, hours: duration.hours, minutes: duration.minutes }, newDuration)).as('minutes');
        field.onChange(newDurationMins);
    };
    const handleBodyClick = (event) => {
        var _a, _b, _c;
        if ((_b = (_a = popup.current) === null || _a === void 0 ? void 0 : _a._popup) === null || _b === void 0 ? void 0 : _b.contains(event.target))
            return;
        if ((_c = anchor.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))
            return;
        setOpen(false);
    };
    useEffect(() => {
        document.body.addEventListener('click', handleBodyClick);
        return () => {
            document.body.removeEventListener('click', handleBodyClick);
        };
    }, []);
    const handlePopupClose = () => __awaiter(this, void 0, void 0, function* () {
        const isValid = yield trigger();
        if (isValid) {
            handleModalSave({ genericEvent: getValues() });
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(InlineEdit, { id: "duration-popup-button", className: "info-value", refComp: anchor, variant: "dropdown", onClick: () => setOpen(!open) }, formValues.allDay ? translate('all_day', { namespace }) : duration.toHuman({ showZeros: false })),
        React.createElement(Popup, { anchor: anchor.current, show: open, ref: popup, onClose: handlePopupClose },
            React.createElement("div", { className: "qmb-popup duration-popup-container" },
                React.createElement("div", { className: "popup__section" },
                    React.createElement(Controller, { name: "allDay", control: control, render: ({ field }) => (React.createElement("label", { className: "qmb-checkbox" },
                            React.createElement("input", { id: field.name, type: "checkbox", checked: field.value, onChange: field.onChange }),
                            translate('all_day', { namespace }))) })),
                React.createElement("hr", { className: "popup__split" }),
                React.createElement("div", { className: "popup__section" },
                    React.createElement(Controller, { name: "durationMins", control: control, rules: {
                            validate: (value) => {
                                if (value === 0)
                                    return translate('validations.duration', { namespace });
                                return true;
                            }
                        }, render: ({ field }) => {
                            return (React.createElement("div", null,
                                React.createElement("fieldset", { className: "form__set--horizontal" },
                                    React.createElement("div", { className: "qmb-input--number duration-field" },
                                        React.createElement("input", { type: "number", id: "duration_days", min: "0", value: duration.days, disabled: formValues.allDay, onChange: (e) => handleDurationChange(field, { days: e.target.value || 0 }) }),
                                        React.createElement("label", { className: "qmb-label", htmlFor: "duration_days" }, translate('days', { namespace }))),
                                    React.createElement("div", { className: "qmb-input--number duration-field" },
                                        React.createElement("input", { type: "number", id: "duration_hours", min: "0", max: "23", value: duration.hours, disabled: formValues.allDay, onChange: (e) => handleDurationChange(field, { hours: e.target.value || 0 }) }),
                                        React.createElement("label", { className: "qmb-label", htmlFor: "duration_hours" }, translate('hours', { namespace }))),
                                    React.createElement("div", { className: "qmb-input--number duration-field" },
                                        React.createElement("input", { type: "number", id: "duration_mins", min: "0", max: "59", value: duration.minutes, disabled: formValues.allDay, onChange: (e) => handleDurationChange(field, { minutes: e.target.value || 0 }) }),
                                        React.createElement("label", { className: "qmb-label", htmlFor: "duration_mins" }, translate('minutes', { namespace })))),
                                errors.durationMins && React.createElement("div", { style: { color: 'red' } }, errors.durationMins.message)));
                        } }))))));
}
export default DurationComp;
